import { cn } from "@/utils/cn";

interface ControlBarStylesProps {
  isControlBarOpened: boolean;
  hasFixedHeight?: boolean;
}

export const getControlBarStyles = ({
  isControlBarOpened,
  hasFixedHeight = true,
}: ControlBarStylesProps) => {
  return {
    container: cn(
      "h-[1px] transition-all duration-500 bg-dark-500 border border-dark-500 w-full overflow-hidden",
      isControlBarOpened ? `border-primary rounded-[8px]` : "",
      isControlBarOpened && !hasFixedHeight ? "h-full" : ""
    ),

    tabsWrapper: "absolute flex h-[30px] items-end gap-2 bottom-[100%] left-5 overflow-auto",

    clearButton: cn(
      "bg-error p-1 h-full flex justify-center items-center rounded-tr-[4px] rounded-tl-[4px] px-3 cursor-pointer text-dark-100"
    ),

    tabButton: ({
      isSelected,
      isActive,
      isControlBarOpened,
      counter,
    }: {
      isSelected?: boolean;
      isActive?: boolean;
      isControlBarOpened?: boolean;
      counter?: number;
    }) =>
      cn(
        "cursor-pointer transition-all h-full duration-500 p-1 bg-dark-500 rounded-tr-[4px] rounded-tl-[4px] border-[1px] border-b-[0] border-transparent px-3",
        {
          "bg-primary": (isSelected && isActive && isControlBarOpened) || counter > 0,
        },
        {
          "bg-primary/20 border-primary":
            (!isSelected && counter > 0) || (isSelected && !isControlBarOpened && counter > 0),
        },
        {
          "font-bold": isSelected,
        }
      ),

    contentSection:
      "px-12 py-6 data-[state=open]:duration-700 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-top-5",
  };
};
